module.exports = __webpack_public_path__ + "img/Machine2.657b6d1c.svg";